var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 37,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M31.627 22.476c-1.274-.343-3.368-.343-4.643 0l-25.17 6.742c-1.274.343-.969 1.226-.615 1.43.353.203 1.033.54 4.798 1.12 2.147.331 3.593.278 4.884.005 5.858-1.098 19.932-4.98 24.763-6.786 1.638-.61.412-1.35-.868-1.692l-3.149-.82Z",
  fill: "#121619",
  fillOpacity: 0.4,
  opacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M29.926 23.206c-1.275-.342-2.603-.133-3.877.21l-22.92 6.136c-1.275.343-2.234.863-.96 1.205 0 0 .643.257 1.586.434.942.177 2.527.466 4.22.29 3.593-.386 17.827-4.713 19.664-5.19 2.983-.771 4.327-1.376 4.74-1.655.407-.278.562-.696-.713-1.039l-1.74-.39Z",
  fill: "#121619",
  fillOpacity: 0.4
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.73 15.81a2.398 2.398 0 0 0-.547-.076c1.001.809 1.435 2.485.97 4.21-.51 1.89-1.923 3.197-3.326 3.186.24.198.519.343.824.423 1.564.418 3.3-.975 3.872-3.111.578-2.143-.225-4.215-1.794-4.633Z",
  fill: "#A2A9B0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.795 19.165c-.155.579.064 1.141.487 1.254.424.112.895-.263 1.05-.841.155-.579-.064-1.14-.487-1.253-.423-.113-.895.262-1.05.84Z",
  fill: "#A2A9B0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m28.283 20.418.833.223.561-2.095-.832-.223-.562 2.095Z",
  fill: "#A2A9B0"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.614 19.376c-.155.579.064 1.141.487 1.253.424.113.895-.262 1.05-.84.155-.579-.064-1.141-.487-1.254-.429-.112-.895.263-1.05.841Z",
  fill: "#697077"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m31.77 17.809-2.159.578 1.082-2.592-.927-.412-1.076 2.592-1.082-2.014-.92.905 1.076 2.014-2.159.578v1.318l2.159-.579-1.077 2.592.921.407 1.082-2.592 1.076 2.02.927-.906-1.082-2.019 2.158-.578v-1.312Z",
  fill: "#697077"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M28.063 19.12c-.123.456.049.895.38.98.332.091.697-.209.82-.658.123-.456-.048-.895-.38-.98-.332-.091-.697.209-.82.658ZM31.768 17.813l.627.182-2.159.578-.626-.182 2.158-.578ZM30.392 22.797l-.627-.177-1.076-2.018.621.182 1.082 2.013Z",
  fill: "#697077"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "m32.394 17.996-2.158.579 1.076-2.598-.921-.407-1.082 2.592-1.076-2.013-.927.905 1.082 2.013-2.158.579v1.312l2.158-.573-1.082 2.592.927.407 1.076-2.592 1.082 2.013.921-.905-1.076-2.013 2.158-.579v-1.312Z",
  fill: "#C1C7CD"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M28.688 19.308c-.123.455.048.894.38.98.332.091.696-.209.82-.659.122-.455-.049-.894-.38-.98-.333-.09-.702.204-.82.659Z",
  fill: "#C1C7CD"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M31.013 14.752c-1.993-.536-4.199 1.237-4.927 3.957-.728 2.72.294 5.36 2.287 5.891 1.992.535 4.198-1.237 4.926-3.958.729-2.72-.294-5.355-2.286-5.89Zm1.515 5.687c-.573 2.137-2.308 3.534-3.872 3.111-1.563-.417-2.372-2.495-1.799-4.632.573-2.137 2.308-3.534 3.872-3.111 1.569.417 2.372 2.49 1.8 4.632Z",
  fill: "#21272A"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M28.145 19.21c-.279 1.04.112 2.04.872 2.244.76.204 1.602-.471 1.875-1.51.278-1.039-.113-2.04-.873-2.244-.76-.203-1.601.472-1.874 1.51Z",
  fill: "#697077"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "m29.016 21.45.388.105 1.006-3.756-.388-.104-1.006 3.756Z",
  fill: "#697077"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M28.503 19.296c-.279 1.04.112 2.04.872 2.244.761.204 1.602-.471 1.875-1.51.278-1.039-.113-2.04-.873-2.244-.755-.203-1.596.471-1.874 1.51Z",
  fill: "#21272A"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M28.37 24.603c-1.992-.536-3.015-3.17-2.287-5.891.729-2.72 2.935-4.493 4.927-3.958.31.086.6.22.862.402-.889-.67-2.345-1.066-3.507-.99-1.757.042-3.503 1.686-4.135 4.053-.631 2.362.06 4.665 1.553 5.58.654.477 2.164 1.05 3.53.9a3.303 3.303 0 0 1-.943-.096Z",
  fill: "#343A3F"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M23.157 21.648c.3-.021 6.656-.809 6.656-.809l.268-3.823-5.81 1.156-1.114 3.476ZM16.65 24.156l5.848 1.57.332-.665-5.847-1.569-.332.664Z",
  fill: "#21272A"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M22.37 27.285a.427.427 0 0 1-.285-.498s1.243-5.714 1.286-5.906c.048-.193.846.026.733.62-.085.45-1.178 5.463-1.178 5.463a.431.431 0 0 1-.557.322ZM17.145 24.653a.427.427 0 0 1-.284-.498l1.285-5.907c.048-.193.846.027.734.621-.086.45-1.179 5.462-1.179 5.462a.424.424 0 0 1-.556.322Z",
  fill: "#21272A"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M18.689 11.651c-.01.054-1.392 8.135-2.613 8.826-1.436.814-5.522 2.067-6.266 2.27-.75.204-5.141-5.96-5.329-7.192-.187-1.231 1.714-6.415 2.592-8.188",
  stroke: "#21272A",
  strokeMiterlimit: 10
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M4.224 4.936c-.06.247.038.484.223.526.18.04.375-.122.435-.369.06-.246-.038-.484-.223-.525-.18-.047-.375.117-.435.368Z",
  fill: "#4D5358"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "m4.449 5.46 11.074 2.665.216-.898L4.665 4.563l-.216.898Z",
  fill: "#21272A"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M15.296 7.592c-.06.247.038.484.222.526.18.041.375-.122.435-.369.06-.246-.038-.484-.223-.525-.18-.046-.374.122-.434.368Z",
  fill: "#121619"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M11.538 24.524s3.32.659 4.13.396c.808-.262 6.115-1.9 6.742-2.367.62-.465 8.396-8.766 8.98-9.575.584-.808.396-3.647.396-3.957 0-.31-5.612-1.478-5.858-1.334a2657.3 2657.3 0 0 1-7.24 3.963c-.011.054-1.398 8.13-2.614 8.826-.664.38-1.269.707-3.052 1.28-1.355-1.794-2.764-4.006-2.87-4.692-.188-1.231.181-6.903 1.06-8.68l-4.68-.876s-5.035 8.817-3.685 10.884l2.838 4.563 5.853 1.57Z",
  fill: "url(#a)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 7,
  width: 29,
  height: 18
}, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M11.281 24.04s3.226.64 4.011.385c.786-.255 5.941-1.847 6.55-2.3.603-.452 8.157-8.515 8.724-9.3.567-.786.385-3.543.385-3.845 0-.302-5.452-1.436-5.691-1.295-.24.14-7.034 3.85-7.034 3.85-.01.051-1.357 7.896-2.538 8.573-.645.369-1.233.686-2.966 1.243-1.316-1.743-2.684-3.892-2.788-4.557-.182-1.197.177-6.706 1.03-8.433l-4.1-1.01s-5.337 8.725-4.026 10.733l2.757 4.432 5.686 1.524Z",
  fill: "url(#b)"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.21 17.062c.19 1.185 4.453 6.959 5.217 6.763.764-.196 5.005-1.35 6.255-2.026 1.24-.67 2.593-6.026 2.806-7.366.212-1.34-2.2-1.783-2.2-1.783l-3.651-.392c0 .005-8.619 3.618-8.428 4.804Z",
  fill: "#21272A"
}))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "m13.021 21.76 1.96 2.249 4.718-1.553-5.001-1.339-1.677.643Z",
  fill: "#121619"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 8.438c-.391.745-1.712 6.224-1.482 8.848.107 1.243 4.59 7.053 5.553 7.02.841-.026 5.495-1.611 6.475-2.056 1.553-.696 3.01-7.33 3.342-8.584.332-1.248 4.884-2.978 5.382-3.288.498-.31 1.333-.568 1.338-.273.006.289.697 2.035.573 2.367-.123.332-8.643 11.026-8.643 11.026s-4.068 1.232-5.01 1.468c-.943.23-6.418.557-6.627.54-.209-.016-1.537-1.253-1.537-1.253s-7.786-5.837-7.76-6.18c0 0-.487-1.408 1.029-1.012 2.088.541 2.956-1.274 3.507-2.624 2.153-5.259-.412-4.905.15-5.923.557-1.023 3.71-.076 3.71-.076Z",
  fill: "url(#d)"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M18.078 13.313s.642.085 1.204.364c.563.278.921 1.012 1.104 2.565.096.835-.156 3.224-.697 5.345-.214.84.905.937 1.612-.295.707-1.232 2.732-5.596 2.234-6.967-.498-1.371-1.029-1.992-1.152-2.057-.128-.064-4.305 1.045-4.305 1.045Z",
  fill: "url(#e)"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "m3.186 17.948 3.7.99c.91.242 1.692.826 2.185 1.624l2.596 4.68-5.975-2.287-2.838-4.562c-.145-.23.07-.514.332-.445Z",
  fill: "#121619"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M7.969 5.421 6.715 7.906s.011.305.461.434c.809.23 2.019.482 2.71.402.862-.097 1.333-.36 1.333-.36s.798-1.354.916-1.574c.53-.964-.487-2.18-2.024-2.377-1.596-.21-2.142.99-2.142.99Z",
  fill: "url(#f)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "h",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 4,
  width: 7,
  height: 5
}, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M7.97 5.421 6.717 7.906s.01.305.46.434c.81.23 2.02.482 2.71.402.863-.097 1.334-.36 1.334-.36s.798-1.354.916-1.574c.53-.964-.488-2.18-2.025-2.377-1.595-.21-2.142.99-2.142.99Z",
  fill: "url(#g)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.885 8.553s.214-2.538.653-2.356c1.574.664 2.533-.45 2.078-1.076-.413-.557.685-.959 1.14-.31.456.642 1.829 1.687 1.78 1.762-.053.08-2.163 1.917-2.163 1.917s-1.55.669-1.716.669c-.166 0-1.473-.156-1.473-.156l-.3-.45Z",
  fill: "url(#i)"
}))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.497 8.442c.112.025.24.054.386.09.893.22 1.59.25 1.993.187.201-.032.533-.12.816-.203a23.525 23.525 0 0 0 .473-.142l.03-.01.01-.003.008.026.008.025-.01.004a9.998 9.998 0 0 1-.141.043c-.093.029-.222.068-.363.109a8.156 8.156 0 0 1-.823.204c-.412.065-1.117.032-2.013-.188-.146-.036-.273-.064-.385-.09l-.165-.037a2.069 2.069 0 0 1-.348-.104.432.432 0 0 1-.2-.159.69.69 0 0 1-.09-.28l.053-.008a.638.638 0 0 0 .082.259.38.38 0 0 0 .177.14c.083.036.192.065.338.1l.164.037Z",
  fill: "#FFDC9C"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M8.85 6.778c.124.466-.048.916-.39 1.007-.338.091-.718-.214-.841-.674-.123-.466.048-.916.39-1.007.338-.097.718.209.842.674Z",
  fill: "url(#j)"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M8.754 7.565c-.359.83-.953 1.221-1.371 1.339l-.868-3.23c.16-.133 1.06-.053 1.816.456l.423 1.435Z",
  fill: "url(#k)"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M8.154 6.968c.241.894-.096 1.757-.75 1.933-.653.177-1.376-.407-1.617-1.296-.24-.894.097-1.756.75-1.933.659-.177 1.382.407 1.617 1.296Z",
  fill: "#fff"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M7.823 7.06c.171.636-.07 1.258-.535 1.38-.466.124-.986-.288-1.157-.926-.172-.637.07-1.258.535-1.381.466-.129.986.289 1.157.926Z",
  fill: "url(#l)"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M4.836 16.104c-.08.251-.311.401-.515.337-.203-.064-.305-.321-.23-.573.08-.252.31-.402.514-.338.21.065.31.322.23.574ZM30.816 9.708c-.53.257-6.437 3.165-7.814 3.502-3.845.937-4.771.166-4.916.096-.444-.208-.187-2.243.113-2.543.637-.637 1.831-.514 3.818-1.377.948-.407 4.241-2.463 5.634-2.28 1.033.133 2.426.486 3.299.77.583.193.39 1.575-.134 1.832Z",
  fill: "#21272A"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M19.137 13.574s.457-1.671.832-2.201c.375-.53 2.865-.573 3.834-1.066.964-.493 3.76-1.617 5.088-2.003 1.173-.343 2.196-.466 2.297-.043.198.798-.112 1.832-.112 1.832s-6.153 3.657-7.99 3.797c-1.842.128-3.95-.316-3.95-.316Z",
  fill: "url(#m)"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M3.223 25.186a.427.427 0 0 1-.284-.498s1.2-5.591 1.27-5.832c.064-.241.835.075.744.583L3.78 24.87a.425.425 0 0 1-.557.317Z",
  fill: "#697077"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M6.736 21.38a2.392 2.392 0 0 0-.547-.075c1.002.808 1.436 2.485.97 4.209-.51 1.89-1.923 3.197-3.326 3.186.241.198.52.343.825.423 1.563.418 3.299-.974 3.872-3.111.573-2.142-.23-4.215-1.794-4.632Z",
  fill: "#A2A9B0"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M3.793 24.728c-.155.578.064 1.14.487 1.253.423.112.895-.262 1.05-.84.155-.58-.064-1.141-.487-1.254-.423-.112-.895.262-1.05.84Z",
  fill: "#A2A9B0"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "m4.281 25.98.833.223.561-2.095-.832-.223-.562 2.095Z",
  fill: "#A2A9B0"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M4.614 24.954c-.155.579.065 1.141.488 1.254.423.112.894-.263 1.05-.841.155-.579-.065-1.14-.488-1.253-.428-.113-.894.262-1.05.84Z",
  fill: "#697077"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "m7.767 23.371-2.158.579 1.082-2.592-.926-.413-1.077 2.592-1.082-2.013-.92.905 1.076 2.013-2.158.579v1.317l2.158-.578-1.077 2.592.921.407 1.082-2.592 1.077 2.013.926-.9-1.082-2.018 2.158-.579v-1.312Z",
  fill: "#697077"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M4.061 24.683c-.123.455.049.894.38.98.333.09.697-.209.82-.659.123-.455-.048-.894-.38-.98-.332-.09-.697.209-.82.659ZM7.768 23.383l.627.182-2.158.573-.627-.177 2.158-.578ZM6.392 28.36l-.626-.182-1.077-2.014.621.182 1.082 2.014Z",
  fill: "#697077"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "m8.398 23.55-2.158.574 1.076-2.592-.921-.407-1.082 2.592-1.076-2.014-.927.905 1.082 2.014-2.158.578v1.312l2.158-.578-1.082 2.597.927.407 1.076-2.592 1.082 2.014.921-.905L6.24 25.44l2.158-.578v-1.312Z",
  fill: "#C1C7CD"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M4.692 24.863c-.123.455.048.894.38.98.332.09.696-.21.82-.659.123-.455-.049-.894-.38-.98-.333-.091-.702.203-.82.659Z",
  fill: "#C1C7CD"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M7.015 20.33c-1.992-.536-4.198 1.237-4.927 3.957-.728 2.72.295 5.36 2.287 5.891 1.992.536 4.198-1.237 4.927-3.957.728-2.72-.295-5.356-2.287-5.891Zm1.516 5.687c-.573 2.137-2.308 3.535-3.872 3.111-1.564-.417-2.373-2.495-1.8-4.632.573-2.137 2.309-3.534 3.872-3.111 1.57.417 2.373 2.49 1.8 4.632Z",
  fill: "#21272A"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M4.143 24.757c-.279 1.04.112 2.04.873 2.244.76.204 1.6-.471 1.874-1.51.278-1.039-.113-2.04-.873-2.244-.76-.203-1.601.471-1.874 1.51Z",
  fill: "#697077"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "m5.014 26.998.388.104 1.006-3.756-.388-.104-1.006 3.756Z",
  fill: "#697077"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M4.503 24.859c-.278 1.039.112 2.04.873 2.244.76.203 1.601-.472 1.874-1.51.279-1.04-.112-2.04-.873-2.244-.755-.204-1.596.471-1.874 1.51Z",
  fill: "#343A3F"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M4.374 30.18c-1.992-.535-3.015-3.17-2.286-5.89.728-2.72 2.934-4.493 4.927-3.957.31.085.6.22.862.401-.89-.67-2.346-1.066-3.508-.99-1.756.042-3.502 1.686-4.134 4.053-.632 2.357.053 4.66 1.553 5.57.653.476 2.163 1.05 3.529.9a2.967 2.967 0 0 1-.943-.086Z",
  fill: "#343A3F"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M5.873 25.84a.427.427 0 0 1-.284-.498l1.286-5.907c.048-.192.846.027.733.622-.085.45-1.178 5.462-1.178 5.462a.424.424 0 0 1-.557.321Z",
  fill: "#343A3F"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  fill: "#121619"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.27.91-.365-.096L29.931 0l.37.096-3.032.814ZM28.346 1.192l-.37-.102L31.003.28l.37.097-3.026.814ZM29.416 1.48l-.37-.096L32.073.57l.37.102-3.026.809ZM30.488 1.77l-.37-.102 3.026-.809.37.097-3.026.814Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 5.439,
  y1: 8.188,
  x2: 7.706,
  y2: 14.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FB9346"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 5.982,
  y1: -2.425,
  x2: 15.332,
  y2: 32.42,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 7.466,
  y1: 6.571,
  x2: 12.527,
  y2: 27.02,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.696,
  stopColor: "#EB5837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#79220E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 20.845,
  y1: 12.266,
  x2: 20.845,
  y2: 22.218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4D5358"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D5358",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 9.496,
  y1: 4.406,
  x2: 9.496,
  y2: 8.757,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF3DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9E00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 9.498,
  y1: 4.406,
  x2: 9.498,
  y2: 8.757,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD591"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 7.256,
  y1: 5.466,
  x2: 16.329,
  y2: 17.988,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.915,
  stopColor: "#460F02"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 7.72,
  y1: 5.107,
  x2: 9.416,
  y2: 7.764,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 6.756,
  y1: 3.742,
  x2: 10.148,
  y2: 8.477,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA549"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604,
  stopColor: "#EC502D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.953,
  stopColor: "#9C6357"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 6.977,
  y1: 6.109,
  x2: 7.283,
  y2: 10.053,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009DFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30B0FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 28.095,
  y1: 9.36,
  x2: 19.771,
  y2: 19.765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#21272A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D4347"
})))));
export default SvgBike;